import React, {useEffect, useState} from "react";
import IconButton from "@material-ui/core/IconButton";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Fade from '@material-ui/core/Fade';

import {Link} from "react-router-dom";
import ListItemText from "@material-ui/core/ListItemText";

import {apollo_useStyles} from "../../atom/Apollo_styles";
import Tooltip from '@material-ui/core/Tooltip';
import {ApolloContext} from "../../atom/Apollo_Context";
import {
  ApolloUserProfileAuth,
  APOLLO_SYSTEM_ADMIN,
  APOLLO_GROUP_ADMIN,
  APOLLO_GROUP_OPERATOR,
  APOLLO_PROFILE_SYSTEM_ADMIN,
  APOLLO_PROFILE_SYSTEM_OPERATOR, APOLLO_SYSTEM_OPERATOR
} from "../../atom/Apollo_Authorization";
import axios from "axios"
import {
  apollo_account_platform_menu_path,
  invoice_path,
  manuals_path,
  adclienticonsapproval_path,
  trackerIdMigration,
} from "../../atom/Apollo_links";

export const SystemManagementMenu = () => {
  const classes = apollo_useStyles();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [platformaccountid, setPlatformAccountId] = useState("");
  const [isZeusPageDisplay, setZeusPageDisplay] = useState(false);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const {state} = React.useContext(ApolloContext)
  const accountid = state.current.accountId;
  const accountgroupid = state.current.accountGroupId;
  console.log(process.env.REACT_APP_TAGS_CREATE_PAGE_USER_IDS)
  const isTagsCreatePagesDisplay: boolean = (process.env.REACT_APP_TAGS_CREATE_PAGE_USER_IDS ?? "").split(",").includes(String(state.userprofile.userId));
  React.useEffect(() => {
    const fetchData = async () => {
      try {
        // APIエンドポイントを構築
        const path = `${process.env.REACT_APP_API_ENDPOINT}${apollo_account_platform_menu_path}/${accountid}`;
  
        // アカウントプラットフォーム情報の取得
        const response = await axios.get(path, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${state.accesstoken}`,
          },
        });
  
        const data = response.data;
        console.log(data);
  
        // menuIdが1かつuseStatusが1のpfAccountIdを取得
        const targetEntry = data.result.find(
          (entry: any) => entry.menuId === 1 && entry.useStatus === 1
        );
  
        const pfAccountId = targetEntry?.pfAccountId;
  
        // ステートにセット
        setPlatformAccountId(pfAccountId);
        setZeusPageDisplay(pfAccountId? true: false)
  
      } catch (error) {
        setZeusPageDisplay(false)
      }
    };
  
    fetchData();
  }, []);

  const isTrackerIdMigraionDisplay: boolean = (process.env.REACT_APP_TRACKERID_MIGRATION_SOURCE_ACCOUNT_GROUPS ?? "").split(",").includes(String(state.current.accountGroupId));

  return (
    <div>
      <Tooltip title="
      各種設定" placement="bottom">
        <IconButton
          aria-label="more"
          aria-controls="system-menu"
          aria-haspopup="true"
          color="inherit"
          onClick={handleClick}
        >
          <img src={"/icon/header_02.png"} alt="setting" height="auto" width="25"/>
        </IconButton>
      </Tooltip>
      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        color="primary"
        keepMounted
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        <Link to="/accountgroups" className={classes.link}>
          <MenuItem onClick={handleClose}>
            <ListItemText primary="アカウント管理"/>
          </MenuItem>
        </Link>
        <ApolloUserProfileAuth role={APOLLO_GROUP_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
        <Link to="/users" className={classes.link}>
          <MenuItem onClick={handleClose}>
            <ListItemText primary="ユーザー管理"/>
          </MenuItem>
        </Link>
        </ApolloUserProfileAuth>
        <ApolloUserProfileAuth role={APOLLO_GROUP_OPERATOR} profile={APOLLO_PROFILE_SYSTEM_OPERATOR}>
        <Link to={"/budgets"} className={classes.link}>
          <MenuItem onClick={handleClose}>
            <ListItemText primary="予算管理"/>
          </MenuItem>
        </Link>
        </ApolloUserProfileAuth>
        <ApolloUserProfileAuth role={APOLLO_GROUP_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
        <Link to={invoice_path} className={classes.link}>
          <MenuItem onClick={handleClose}>
            <ListItemText primary="確定請求金額"/>
          </MenuItem>
        </Link>
        </ApolloUserProfileAuth>
        <ApolloUserProfileAuth role={APOLLO_SYSTEM_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
        <Link to={"/masterproducts"} className={classes.link}>
          <MenuItem onClick={handleClose}>
            <ListItemText primary="マスター管理"/>
          </MenuItem>
        </Link>
        <Link to="/info" className={classes.link}>
          <MenuItem onClick={handleClose}>
             <ListItemText primary="メッセージ管理"/>
          </MenuItem>
        </Link>
        </ApolloUserProfileAuth>
        <ApolloUserProfileAuth role={APOLLO_GROUP_OPERATOR} profile={APOLLO_PROFILE_SYSTEM_OPERATOR}>
          <Link to="/history" className={classes.link}>
            <MenuItem onClick={handleClose}>
              <ListItemText primary="履歴管理"/>
            </MenuItem>
          </Link>
        </ApolloUserProfileAuth>
        <ApolloUserProfileAuth role={APOLLO_SYSTEM_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
          <Link to={manuals_path} className={classes.link}>
            <MenuItem onClick={handleClose}>
              <ListItemText primary="マニュアル管理"/>
            </MenuItem>
          </Link>
        </ApolloUserProfileAuth>
        <ApolloUserProfileAuth role={APOLLO_SYSTEM_OPERATOR} profile={APOLLO_PROFILE_SYSTEM_OPERATOR}>
          <Link to={adclienticonsapproval_path} className={classes.link}>
            <MenuItem onClick={handleClose}>
              <ListItemText primary="アイコン審査"/>
            </MenuItem>
          </Link>
        </ApolloUserProfileAuth>
        {isTrackerIdMigraionDisplay ?
          <ApolloUserProfileAuth role={APOLLO_SYSTEM_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
            <Link to={trackerIdMigration} className={classes.link}>
              <MenuItem onClick={handleClose}>
                <ListItemText primary="トラッカーID移行"/>
              </MenuItem>
            </Link>
          </ApolloUserProfileAuth> : <></>
        }
        {isTagsCreatePagesDisplay && isZeusPageDisplay ?
        <ApolloUserProfileAuth role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
          <Link to={`/crassetedit/zeus/tags/${accountgroupid}/${accountid}/${platformaccountid}`} className={classes.link}>
            <MenuItem onClick={handleClose}>
              <ListItemText primary="タグアセット登録"/>
            </MenuItem>
          </Link>
        </ApolloUserProfileAuth> : <></>
        }
      </Menu>
    </div>
  );
}
